/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import PreviewExpand from '@prospectus/common/ui/PreviewExpand';

function MoreInfo({
  additionalInformation,
  intl,
  commonMessages,
  mobile,
}) {
  const messages = defineMessages(
    {
      'prospectus.course.detail.additional': {
        id: 'prospectus.course.detail.additional',
        description: 'Header text for the additional information section',
        defaultMessage: 'More about this course',
      },
    },
  );
  if (mobile) {
    return (
      <>
        <p className="mt-3">
          <strong>
            {intl.formatMessage(messages['prospectus.course.detail.additional'])}
          </strong>
        </p>
        <div className="html-data" dangerouslySetInnerHTML={{ __html: additionalInformation }} />
      </>
    );
  }
  return (
    <PreviewExpand
      cta={
        {
          labelToExpand: intl.formatMessage(commonMessages.showMore),
          labelToMinimize: intl.formatMessage(commonMessages.showLess),
          id: 'additional_information',
          className: 'btn btn-link mt-2 pt-1 pt-sm-2 px-0 pb-0',
        }
      }
      heading={(
        <h1 className="pt-3 mt-3 pt-sm-5 mt-sm-2">
          {intl.formatMessage(messages['prospectus.course.detail.additional'])}
        </h1>
        )}
      sectionTitle={intl.formatMessage(messages['prospectus.course.detail.additional'])}
      excludeIcon
      innerClassName="m-0"
    >
      <div className="mt-2 html-data" dangerouslySetInnerHTML={{ __html: additionalInformation }} />
    </PreviewExpand>
  );
}

MoreInfo.propTypes = {
  additionalInformation: PropTypes.string,
  intl: intlShape.isRequired,
  commonMessages: PropTypes.shape({
    showMore: PropTypes.shape({}).isRequired,
    showLess: PropTypes.shape({}).isRequired,
  }).isRequired,
  mobile: PropTypes.bool,
};

MoreInfo.defaultProps = {
  additionalInformation: null,
  mobile: false,
};

export default injectIntl(MoreInfo);
